import React from 'react'

export class CommentBox extends React.Component {
  componentDidMount() {
    window.addEventListener('scroll', this.onceScroll.bind(this), {
      once: true,
    })
  }

  onceScroll(evt) {
    evt.preventDefault()
    const { url, identifier } = this.props
    window.disqus_config = function() {
      this.page.url = 'https://esmer-games.github.io' + url
      this.page.identifier = identifier
    }
    var d = document,
      s = d.createElement('script')
    s.src = 'https://esmer-games.disqus.com/embed.js'
    s.setAttribute('data-timestamp', +new Date())
    ;(d.head || d.body).appendChild(s)
  }

  /**
   * Render only the place where the comments will be.
   * Then asynchronous-user-triggered load is done.
   * @override
   */
  render() {
    return <div id="disqus_thread" />
  }
}
